import React from 'react';

export default function IndexSectionFooter4() {
    return (
        <React.Fragment>
            <>
                <section className="py-20">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap -m-4 mb-20">
                            <div className="w-full lg:w-1/4 p-4">
                                <a href="#" className="inline-block">
                                    <span>FindAMeal</span>
                                </a>
                            </div>
                            <div className="w-full lg:w-3/4 p-4">
                                <ul className="flex flex-wrap lg:justify-end">
                                    <li className="mb-4 lg:mb-0 mr-6 md:mr-12"><a
                                        className="text-sm font-bold text-black" href="#about">About</a></li>
                                    <li className="mb-4 lg:mb-0 mr-6 md:mr-12"><a
                                        className="text-sm font-bold text-black" href="#feature-query">Features</a></li>
                                    <li className="mb-4 lg:mb-0 mr-6 md:mr-12"><a
                                        className="text-sm font-bold text-black" href="#contact">Contact Us</a></li>
                                    <li>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="flex justify-between items-center flex-wrap gap-4">
                            <p className="text-gray-500 text-sm">All rights reserved © findameal 2025</p>
                            <ul className="flex items-center gap-8">
                                <li>
                                    <a className="inline-block" href="https://www.facebook.com/findamealai/">
                                        <img src="cronos-assets/logos/brands/facebook.svg" alt/>
                                    </a>
                                </li>
                                <li>
                                    <a className="inline-block"
                                       href="https://x.com/souza_gusthavo/status/1736366445510922461">
                                        <img src="cronos-assets/logos/brands/twitter.svg" alt/>
                                    </a>
                                </li>
                                <li>
                                    <a className="inline-block" href="https://www.instagram.com/findamealai/">
                                        <img src="cronos-assets/logos/brands/Instagram.svg" alt/>
                                    </a>
                                </li>
                                <li>
                                    <a className="inline-block" href="https://github.com/gusthavosouza">
                                        <img src="cronos-assets/logos/brands/github.svg" alt/>
                                    </a>
                                </li>
                                <li>
                                    <a className="inline-block" href="https://www.linkedin.com/company/fam-findameal">
                                        <img src="cronos-assets/logos/brands/LinkedIn.svg" alt/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>


            </>
        </React.Fragment>
    );
}

